export default function handleUserNotLoggedIn (response) {
  if (response.status === 401) {
    // Implement this with our log in strategy
    Promise.reject(response)
  }
  return Promise.resolve(response)
}



// WEBPACK FOOTER //
// ./src/http/interceptors/handleUserNotLoggedIn.js